var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ItemsTable',{class:{ 'skeleton-loading': _vm.showSkeletons },attrs:{"title":"Available Workspaces","headers":_vm.headers,"rows":_vm.displayRows,"get-data":_vm.getData,"has-more-data":_vm.hasMoreData,"is-loading":_vm.isLoading && !_vm.showSkeletons},on:{"clickRow":_vm.highlightRow}})
}
var staticRenderFns = []

export { render, staticRenderFns }